




import { Component, Mixins, Prop } from "vue-property-decorator";
import { ImageKinds } from "../../../../domain/document";
import { IImageDrawable } from "../../../../domain/document/items";
import { EditingDocument } from "..";
import { Patient } from "../../../../domain/patient";
import { ClaioViewerLauncher } from "../../../../domain/claio";

@Component
export default class ClaioAdapter extends Mixins() {
  @Prop()
  source: EditingDocument;

  isContentShowable(source: IImageDrawable): boolean {
    return source.claioImageId
        && (0 <= [ImageKinds.ClaioImage, ImageKinds.ClaioMovie].indexOf(source.imageKind));
  }

  get patient(): Patient {
    return this.source
      ? this.source.attributes.patient
      : null;
  }

  showContent(source: IImageDrawable): void {
    if (!this.isContentShowable(source)) {
      this.$error("Claio起動失敗", "Claioの起動対象のsourceではありません。実装を確認してください。");
    }
    const launcher = new ClaioViewerLauncher(this.$configuration);
    const isMovie = source.imageKind === ImageKinds.ClaioMovie;
    const documentDepartmentId = this.source.attributes.department ? this.source.attributes.department.id : null;
    launcher.launch(this.$store.getters.user, this.patient, source.claioImageId, source.imageDepartmentId, isMovie, documentDepartmentId)
    .catch(e => {
      this.$error("Claio画像ビューアー起動失敗", "Claio画像ビューアーの起動処理中にエラーが発生しました。", e);
    });
  }
}
